<template>
    <div id="counts-metric" class="tile" :class="[{ 'is-parent': isParent }, metricSize]">
        <article class="tile is-child notification is-white metric" :class="metricColor">
            <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false"></b-loading>
            <div class="columns is-mobile" v-if="!loading">
                <div class="column">
                    <p class="title has-icon">
                        <b-icon :icon="metricData.icon.icon" :key="metricData.icon.icon" :type="`is-${metricData.icon.type}`"></b-icon>
                        <span>{{ theTitle }}</span>
                    </p>
                </div>
            </div>
            <b-notification v-if="!loading && !hasChartData" :closable="false">{{ noDataMessage }}</b-notification>
            <div class="columns is-mobile is-multiline m-b-0" v-if="!loading && hasChartData">
                <div class="column is-one-third is-6-mobile"
                     v-for="(statistic, statisticKey, index) in metricData.statistics" :key="statisticKey">
                    <div class="metric-count has-link" :class="{'is-danger': statistic.count > 0}"
                         v-on:click="handleLink(statistic)">
                        <div class="pull-right has-text-right help" v-if="statistic.help !== ''">
                            <b-tooltip :label="statistic.help" :position="tooltipPos(index)" type="is-info">
                                <b-icon icon="question-circle" size="is-small" />
                            </b-tooltip>
                        </div>
                        <span class="count">{{ statistic.display_count ? statistic.display_count : statistic.count }}</span>
                        <span class="label">{{ statistic.label }}</span>
                    </div>
                </div>
            </div>

            <p class="help m-t-0" v-if="metricData.help">{{ metricData.help }}</p>
        </article>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CountsMetric',
  components: {
    //
  },
  props: {
    metric: {
      type: String
    },
    title: {
      type: String,
      default: 'Totals'
    },
    metricSize: {
      default: 'is-4',
      type: String
    },
    route: {
      type: String
    },
    filter: {
      default: 'unknown',
      type: String
    },
    isParent: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      loading: false
    }
  },
  watch: {
    modelUpdatedAt: function () {
      this.getMetric(true)
    }
  },
  computed: {
    ...mapState({
      metrics: state => state.metrics.all,
      modelUpdatedAt: state => state.modelUpdatedAt,
      dataChanged: state => state.dataChanged,
      accountActiveTabs: state => state.accountActiveTabs
    }),
    theTitle () {
      if (this.metricData.title !== undefined) return this.metricData.title
      return this.title
    },
    noDataMessage () {
      if (this.metricData.empty !== undefined) return this.metricData.empty
      return 'Not enough data to render chart.'
    },
    hasChartData () {
      if (this.loading) return false
      if (Object.keys(this.metricData).length === 0) return false

      return true
    },
    metricColor () {
      if (!this.hasChartData) return 'metric-primary'

      return 'metric-' + this.metricData.icon.type
    },
    metricData () {
      if (this.metrics === undefined) return {}
      if (this.metrics[this.metric] === undefined) return {}
      return this.metrics[this.metric]
    }
  },
  methods: {
    getMetric (force) {
      if (!force) force = false

      if (!this.hasChartData) {
        this.loading = true
      }

      this.$store.dispatch('metrics/getMetric', { metric: this.metric, qs: { force: force } }).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getQueryString (filter, id) {
      let query = {}
      query['filter__' + filter] = id
      return query
    },
    handleLink (statistic) {
      let action = statistic.action
      let model = statistic.action.model

      if (this.metricData.model === 'accounts') {
        let tab = 0

        if (model.includes('account_properties')) tab = 1
        if (model.includes('account_files')) tab = 2
        if (model.includes('account_invites')) tab = 3

        this.$store.commit('setAccountActiveTab', {
          'account_id': this.metricData.model_id,
          'tab': tab
        })

        let element = document.getElementById('app')
        if (typeof (element) !== 'undefined' && element != null) {
          document.getElementById('app').scrollTop = 0
        }
      }

      if (statistic.label !== undefined) {
        this.$store.commit('initDatatableState', action.model)
        this.$store.commit('updateDatatableSubTitle', {
          'subtitle': statistic.label,
          'model': action.model
        })
      }

      if (action.filters !== undefined) {
        this.$store.commit('initDatatableState', action.model)
        this.$store.commit('updateDatatableStateFilters', {
          'model': action.model,
          'filters': action.filters
        })
      }

      if (action.search !== undefined) {
        this.$store.commit('initDatatableState', action.model)
        this.$store.commit('updateDatatableStateSearch', {
          'model': action.model,
          'search': action.search
        })
      }
    },
    tooltipPos (index) {
      // Required for IE11
      if (index === 0) return 'is-right'
      if ((index + 1) % 3 === 0) return 'is-left'
      if (index % 3 === 0) return 'is-right'

      return 'is-top'
    }
  },
  created () {
    this.getMetric()
  }
}
</script>

<style lang="scss">
#counts-metric { overflow: hidden; } // ie11 fix
</style>



// WEBPACK FOOTER //
// src/components/Metrics/CountsMetric.vue